import autosize from "autosize";

window.autosize = autosize;